import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { DataService } from '../../shared/services/data.service';
import { BuiltInChecklistPair, ResolvedBuiltInChecklist, UpsertBuiltInChecklistRequest } from '../models/built-in-checklist.model';

@Injectable({
  providedIn: 'root',
})
export class BuiltInChecklistService {
  private readonly basePath = 'api/built-in-checklists';
  private readonly dataService = inject(DataService);

  public getAll(): Observable<BuiltInChecklistPair[]> {
    return this.dataService.get<BuiltInChecklistPair[]>(this.basePath);
  }

  public getResolved(): Observable<ResolvedBuiltInChecklist[]> {
    return this.dataService.get<ResolvedBuiltInChecklist[]>(`${this.basePath}/resolved`);
  }

  public upsert(request: UpsertBuiltInChecklistRequest): Observable<BuiltInChecklistPair> {
    return this.dataService.put<UpsertBuiltInChecklistRequest, BuiltInChecklistPair>(this.basePath, request);
  }
}
